module.exports = __webpack_public_path__ + "img/gnzs9.754239ca.png";